import { t } from '@lingui/macro';

export enum GraphErrataEnum {
  SiteHasNoChannelConfig = 'SiteHasNoChannelConfig',
  SiteHasNoChannelType = 'SiteHasNoChannelType',
  SiteChannelHasNoPointsData = 'SiteChannelHasNoPointsData',
}

export enum BaseErrorCodes {
  SiteDeviceNotLinked = 'Site.DeviceNotLinked',
  AlarmDeviceIsNotMicrolog = 'Alarm.DeviceIsNotMicrolog',
  AlarmDeviceIsNotUnilog = 'Alarm.DeviceIsNotUnilog',
  AlarmDeviceIsNotMultilog = 'Alarm.DeviceIsNotMultilog',
  AlarmDeviceDoesNotSupportBinaryAlarms = 'Alarm.DeviceDoesNotSupportBinaryAlarms',
  AlarmDeviceDoesNotSupportServerAlarms = 'Alarm.DeviceDoesNotSupportServerAlarms',
  FleetReportInvalidOrderByColumn = 'FleetReport.InvalidOrderByColumn',
}

export enum ExportErrorCodes {
  ExportOnlySupportsSingleSite = "Graph.ExportOnlySupportsSingleSite",
  ExportRequiresChannel = "Graph.ExportRequiresChannel",
  ExportDoesNotSupportChannel = "Graph.ExportDoesNotSupportChannel",
  ExportNotSupportedForSite = "Graph.ExportNotSupportedForSite"
}

export type ErrorCodes = BaseErrorCodes | GraphErrataEnum | ExportErrorCodes;

export const ErrorCodesDictionaryFn = (): Record<ErrorCodes, string> => ({
  [BaseErrorCodes.SiteDeviceNotLinked]: t`Device is not linked`,
  [BaseErrorCodes.AlarmDeviceIsNotMicrolog]: t`Device is not microlog, microlog alarm settings are not supported`,
  [BaseErrorCodes.AlarmDeviceIsNotUnilog]: t`Device is not unilog, unilog alarm settings are not supported`,
  [BaseErrorCodes.AlarmDeviceIsNotMultilog]: t`Device is not multilog, legacy alarm settings are not supported`,
  [BaseErrorCodes.AlarmDeviceDoesNotSupportBinaryAlarms]: t`The logger does not support binary alarm types`,
  [BaseErrorCodes.AlarmDeviceDoesNotSupportServerAlarms]: t`The logger does not support server alarm types`,
  [BaseErrorCodes.FleetReportInvalidOrderByColumn]: t`Unable to sort on the specified column`,
  [GraphErrataEnum.SiteHasNoChannelConfig]: t`Unable to graph without channel information`,
  [GraphErrataEnum.SiteHasNoChannelType]: t`Unable to graph without channel type`,
  [GraphErrataEnum.SiteChannelHasNoPointsData]: t`Unable to graph without channel points data`,
  [ExportErrorCodes.ExportOnlySupportsSingleSite]: t`The selected export can only be done for a single site`,
  [ExportErrorCodes.ExportRequiresChannel]: t`The selected export requires a channel to be specified`,
  [ExportErrorCodes.ExportDoesNotSupportChannel]: t`The selected export cannot specify a channel`,
  [ExportErrorCodes.ExportNotSupportedForSite]: t`The site does not support the selected export`,
});
